<template>
  <div class="table-layout">
    <!-- 搜索表单部分 -->
    <div class="table-search-form">
      <div class="form-wrap">
        <slot name="search-form"></slot>
      </div>
    </div>
    <!-- 列表和分页部分 -->
    <div class="table-content">
      <div class="table-wrap">
        <slot name="table-wrap"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TableLayout'
}
</script>

<style lang="scss">
@import "../styles/tablelayout";
.table-layout{
    text-align: left;
}
.el-container {
  background: #F7F8F9;
  min-height: calc(100vh);
}
// 头部
.table-header {
  overflow: hidden;
  padding: 12px 16px;
  // 页面路径
  .el-breadcrumb {
    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #ABB2BE;
        font-size: 12px;
      }
      &:last-of-type .el-breadcrumb__inner {
        color: #606263;
        font-size: 14px;
      }
    }
  }
}
// 搜索
.table-search-form {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  .form-wrap {
    padding: 10px 10px 10px 0px;
    width: 100%;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
    &:empty {
      padding: 0;
    }
  }
  section {
    display: inline-block;
  }
  .item-width.el-input{
    width: 155px;
    display: inline-block;
  }
}
// 列表和分页
.table-content {
  margin-top: 10px;
  padding: 0 10px;
  .table-wrap {
    padding: 10px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
    .fix-footer{
      padding: 5px 0;
      height: 45px;
      position: relative;
    }
    // 工具栏
    .toolbar {
      display: inline-block;
      li {
        display: inline-block;
      }
    }
    // 表格
    .el-table {
      // 复选框列
      .el-table-column--selection {
        .cell {
          text-align: center !important;
        }
      }
    }
    // 分页
    .table-pagination {
      text-align: center;
    //   display: inline-block;
    //   position: absolute;
    //   right: 0;
    }
  }
}
@media (min-width: 1400px) and (max-width: 1600px) {
  .table-search-form {
    .item-width{
      width: 160px;
    }
  }
}
@media (min-width: 1200px) and (max-width: 1399px) {
  .table-search-form {
    .item-width{
      width: 120px;
    }
  }
}
@media (max-width: 1199px) {
  .table-search-form {
    .item-width{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/TableLayout.vue